import { Link } from "react-router";
import { FileUp, Info } from "lucide-react";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { Button } from "@/shared/components/ui/button";

export function ResourceUploadPage() {
  return (
    <>
      <title>Upload Resource - Researchly</title>
      <div className="flex flex-col gap-6 p-4 sm:p-6">
        <div className="flex items-center gap-3">
          <div className="flex size-11 items-center justify-center rounded-2xl border border-primary/15 bg-primary/5 text-primary">
            <FileUp className="size-5" />
          </div>
          <div>
            <h1 className="text-3xl font-semibold tracking-tight">
              Upload resource
            </h1>
            <p className="text-sm text-muted-foreground">
              Resource uploads are pending the backend-supabase#25 upload
              lifecycle and the RES-V1 contract.
            </p>
          </div>
        </div>

        <Card className="max-w-2xl border-border/60">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Info className="size-4" />
              Not yet wired to RES-V1
            </CardTitle>
            <CardDescription>
              This route is available so dashboard navigation is stable today.
              The actual upload lifecycle will be added after
              backend-supabase#25 defines the storage upload, download, and
              delete contract for RES-V1.
            </CardDescription>
          </CardHeader>
          <div className="px-6 pb-6">
            <Button asChild variant="outline" className="rounded-xl">
              <Link to="/resources">Back to resources</Link>
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
}
